/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Protestant_Theology23Inputs */

const en__field_enum_study_protestant_theology23 = /** @type {(inputs: _Field_Enum_Study_Protestant_Theology23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protestant Theology`)
};

const de__field_enum_study_protestant_theology23 = /** @type {(inputs: _Field_Enum_Study_Protestant_Theology23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evangelische Theologie`)
};

/**
* | output |
* | --- |
* | "Protestant Theology" |
*
* @param {_Field_Enum_Study_Protestant_Theology23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_protestant_theology23 = /** @type {((inputs?: _Field_Enum_Study_Protestant_Theology23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Protestant_Theology23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_protestant_theology23(inputs)
	return de__field_enum_study_protestant_theology23(inputs)
});
export { _field_enum_study_protestant_theology23 as "_field_enum_STUDY_PROTESTANT_THEOLOGY" }